import { Component, OnInit } from '@angular/core';
import { Router, NavigationError } from '@angular/router';
import { filter } from 'rxjs/operators';

const RELOAD_GUARD_KEY = 'sp_chunk_reload_at';

@Component({
  selector: 'sp-root',
  template: '<router-outlet></router-outlet>',
  standalone: false,
})
export class AppComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit(): void {
    // Recover from lazy-chunk load failures. On qastg a freshly-deployed (or
    // cold-cached) chunk can be served as index.html instead of JS, which makes
    // the router silently abort the navigation — the CTA appears dead. Detect
    // that and reload once to pull a self-consistent set of files.
    this.router.events
      .pipe(filter((e): e is NavigationError => e instanceof NavigationError))
      .subscribe(e => {
        if (!this.isChunkLoadError(e.error)) return;

        // Guard against reload loops: only auto-reload once per 30s window.
        const now  = Date.now();
        const last = Number(sessionStorage.getItem(RELOAD_GUARD_KEY) ?? '0');
        if (now - last < 30_000) return;

        sessionStorage.setItem(RELOAD_GUARD_KEY, String(now));
        window.location.assign(e.url || window.location.href);
      });
  }

  private isChunkLoadError(error: unknown): boolean {
    const msg = String((error as { message?: string })?.message ?? error ?? '');
    const name = String((error as { name?: string })?.name ?? '');
    return name === 'ChunkLoadError' || /Loading chunk [\w-]+ failed|dynamically imported module/i.test(msg);
  }
}
